














    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
import User from '../../../store/entities/user';
    @Component({

    })
    export default class Authorization extends AbpBase {

        created() {
     
            //this.$nextTick(() => {
            //    setTimeout(() => {
            //        this.get();
            //    }, 2000);
            //});
          this.get();
        }
        async get() {

            //var shopid = parseInt(abp.getQueryVariable("shop_id"));
            //if (!shopid) {
            //    shopid = 0;
            //}
            //var mainaccountid = parseInt(abp.getQueryVariable("main_account_id"));
            //if (!mainaccountid) {
            //    mainaccountid = 0;
            //}
            var codestring = abp.getQueryVariable("code");
            var statestring = abp.getQueryVariable("state");
            var issq = this.$store.dispatch({
                type: 'authorizationShop/addauthorizationshop',
                data: { code: codestring, state: statestring }
            }).finally(() => {
                this.$Notice.open({
                    title: '通知',
                    desc: issq ? '授权成功！！！' : '授权失败！！！'
                });
            });
     
            
       
            
        }

        async returnBack() {
            var code = abp.getQueryVariable("code");
            var name = this.$route.name;
            this.$store.commit('app/removeTag', name);
            this.$store.commit('app/closePage', name);
            let pageOpenedList = this.$store.state.app.pageOpenedList;
            localStorage.pageOpenedList = JSON.stringify(pageOpenedList);
            let lastPageName = '';
            if (pageOpenedList.length > 1) {
                lastPageName = pageOpenedList[1].name;
            } else {
                lastPageName = pageOpenedList[0].name;
            }
            this.$router.push({
                name: lastPageName
            });
        }
    }
